import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export const inventoryService = {

    getItems() {
        return axios.get(
            API_URL + "inventory/GetItems"
        );
    },

    getItem(id) {
        return axios.get(
            API_URL + "inventory/GetItem/" + id
        );
    },

    addItem(item) {
        return axios.post(
            API_URL + "inventory/AddItem",
            item
        );
    },

    updateItem(item) {
        return axios.post(
            API_URL + "inventory/UpdateItem",
            item
        );
    },

    deleteItem(item) {
        return axios.post(
            API_URL + "inventory/DeleteItem",
            item
        );
    },

    getInventoryStockOverview() {
        return axios.get(
            API_URL +
            "inventory/GetInventoryStockOverview"
        );
    },

    // ------------------------------------------------
    // VARIANTS
    // ------------------------------------------------

    getVariants(itemId) {
        return axios.get(
            API_URL +
            "inventory/GetVariants/" +
            itemId
        );
    },

    getVariant(id) {
        return axios.get(
            API_URL +
            "inventory/GetVariant/" +
            id
        );
    },

    addVariant(variant) {
        return axios.post(
            API_URL +
            "inventory/AddVariant",
            variant
        );
    },

    updateVariant(variant) {
        return axios.post(
            API_URL +
            "inventory/UpdateVariant",
            variant
        );
    },

    deleteVariant(variant) {
        return axios.post(
            API_URL +
            "inventory/DeleteVariant",
            variant
        );
    },

    //-------------------------------------------------
    // STOCK
    //-------------------------------------------------

    getStockByVariantId(variantId) {
        return axios.get(
            API_URL +
            "inventory/GetStockByVariantId/" +
            variantId
        );
    },

    addStock(stock) {
        return axios.post(
            API_URL +
            "inventory/AddStock",
            stock
        );
    },

    updateStock(stock) {
        return axios.post(
            API_URL +
            "inventory/UpdateStock",
            stock
        );
    },

    deleteStock(stock) {
        return axios.post(
            API_URL +
            "inventory/DeleteStock",
            stock
        );
    },

    //-------------------------------------------------
    // TRANSACTIONS
    //-------------------------------------------------
    getStockTransactions(variantId) {
        return axios.get(
            API_URL +
            "inventory/GetStockTransactions/" +
            variantId
        );
    },

    addStockTransaction(transaction) {
        return axios.post(
            API_URL +
            "inventory/AddStockTransaction",
            transaction
        );
    },

    getItemTypes() {
        return axios.get(
            API_URL +
            "inventory/GetItemTypes"
        );
    },

    getUnitTypes() {
        return axios.get(
            API_URL +
            "inventory/GetUnitTypes"
        );
    },

    getTransactionTypes() {
        return axios.get(
            API_URL +
            "inventory/GetTransactionTypes"
        );
    },

    //BOOM
    getBillOfMaterials(parentVariantId) {
        return axios.get(
            API_URL +
            "inventory/GetBillOfMaterials/" +
            parentVariantId
        );
    },

    addBillOfMaterial(data) {
        return axios.post(
            API_URL +
            "inventory/AddBillOfMaterial",
            data
        );
    },

    updateBillOfMaterial(data) {
        return axios.post(
            API_URL +
            "inventory/UpdateBillOfMaterial",
            data
        );
    },

    deleteBillOfMaterial(id) {
        return axios.post(
            API_URL +
            "inventory/DeleteBillOfMaterial/" +
            id
        );
    },

    getAllVariants() {
        return axios.get(
            API_URL +
            "inventory/GetAllVariants"
        );
    },

    getProductionPreview(variantId, quantity) {
        return axios.get(
            API_URL +
            "inventory/GetProductionPreview/" +
            variantId +
            "/" +
            quantity
        );
    },

    produceVariant(data) {
        return axios.post(
            API_URL +
            "inventory/ProduceVariant",
            data
        );
    },

    getSaleProfitability(stockTransactionId) {
        return axios.get(
            API_URL +
            "inventory/GetSaleProfitability/" +
            stockTransactionId
        );
    },

    saveSaleProfitability(data) {
        return axios.post(
            API_URL +
            "inventory/SaveSaleProfitability",
            data
        );
    },

    getSaleProfitabilityOverview() {
        return axios.get(
            API_URL +
            "inventory/GetSaleProfitabilityOverview"
        );
    },

    // Dodaj do inventoryService:

    getInventoryActivity(params = {}) {
        return axios.get(
            API_URL + "inventory/GetInventoryActivity",
            { params }
        );
    },
    createFromProduct(productId) {

        return axios.post(
            API_URL + "inventory/CreateFromProduct/" +
            productId
        );

    },
};